
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/bluecore",
      function () {
        return require("private-next-pages/destinations/bluecore.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/bluecore"])
      });
    }
  